import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "milestone-carousel" }
const _hoisted_2 = { class: "milestone-carousel__grid" }
const _hoisted_3 = { class: "milestone-carousel__wrapper" }
const _hoisted_4 = { class: "milestone-carousel__milestone" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridLevels = _resolveComponent("GridLevels")!
  const _component_MilestoneTooltip = _resolveComponent("MilestoneTooltip")!
  const _component_MilestoneCell = _resolveComponent("MilestoneCell")!
  const _component_ElPopover = _resolveComponent("ElPopover")!
  const _component_MilestoneCarouselDescription = _resolveComponent("MilestoneCarouselDescription")!
  const _component_ElCarouselItem = _resolveComponent("ElCarouselItem")!
  const _component_ElCarousel = _resolveComponent("ElCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ElCarousel, {
        ref: "carousel",
        autoplay: false,
        "initial-index": _ctx.currentPosition - 1,
        arrow: "always",
        height: "310px",
        "indicator-position": "none",
        type: "card",
        onChange: _ctx.changeCarouselPosition
      }, {
        default: _withCtx(() => [
          _createVNode(_component_GridLevels, {
            "current-level": _ctx.currentLevel,
            "levels-count": _ctx.levelsCount
          }, null, 8, ["current-level", "levels-count"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
            return (_openBlock(), _createBlock(_component_ElCarouselItem, {
              key: category.name,
              ref_for: true,
              ref: "carousel-items",
              class: _normalizeClass([[
            {
              'milestone-carousel__category--right':
                _ctx.changeRightItemTransformStyles(category.order),
              'milestone-carousel__category--left':
                _ctx.changeLeftItemTransformStyles(category.order),
            },
          ], "milestone-carousel__category"]),
              name: category.name
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "milestone-carousel__category-name",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hide-carousel')))
                }, [
                  _createElementVNode("p", null, _toDisplayString(category.name), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    alt: "minimize",
                    src: "/img/icons/minimize--black.svg"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.milestones, (milestone) => {
                      return (_openBlock(), _createBlock(_component_ElPopover, {
                        key: milestone.level,
                        "close-delay": 0,
                        placement: "top",
                        "popper-class": "px-popover--light milestone-cell-popover",
                        width: "242px",
                        trigger: "click",
                        onHide: _ctx.onTooltipHide,
                        onShow: ($event: any) => (_ctx.onTooltipShow(milestone))
                      }, {
                        reference: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_MilestoneCell, {
                            key: milestone.level,
                            class: _normalizeClass({
                      'milestone-carousel__milestone--blurred':
                        _ctx.isMilestoneBlurred(milestone),
                    }),
                            color: category.color,
                            completed: milestone.completed,
                            critical: milestone.critical,
                            "evidence-provided": milestone.evidenceProvided,
                            future: milestone.future,
                            "in-progress": milestone.inProgress,
                            planned: milestone.planned
                          }, null, 8, ["class", "color", "completed", "critical", "evidence-provided", "future", "in-progress", "planned"]))
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_MilestoneTooltip, {
                            "category-color": category.color,
                            "category-name": category.name,
                            "has-evidence": milestone.evidenceProvided,
                            "is-future-milestone": milestone.future,
                            "is-milestone-complete": milestone.completed,
                            "is-milestone-critical": milestone.critical,
                            "is-milestone-in-progress": milestone.inProgress,
                            "is-milestone-planned": milestone.planned,
                            "is-visitor": _ctx.isVisitor,
                            "level-number": milestone.level,
                            "milestone-description": milestone.description,
                            "target-date": milestone.targetDate,
                            onComplete: ($event: any) => (
                    _ctx.onMilestoneCompleteClick(category.id, milestone.level)
                  ),
                            onPlan: ($event: any) => (_ctx.onMilestonePlanClick(category.id, milestone.level))
                          }, null, 8, ["category-color", "category-name", "has-evidence", "is-future-milestone", "is-milestone-complete", "is-milestone-critical", "is-milestone-in-progress", "is-milestone-planned", "is-visitor", "level-number", "milestone-description", "target-date", "onComplete", "onPlan"])
                        ]),
                        _: 2
                      }, 1032, ["onHide", "onShow"]))
                    }), 128))
                  ]),
                  _createVNode(_component_MilestoneCarouselDescription, { category: category }, null, 8, ["category"])
                ])
              ]),
              _: 2
            }, 1032, ["class", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["initial-index", "onChange"])
    ])
  ]))
}